<template>
  <div class="main">
    <transition name="screen">
      <!--div class="payment section" v-if="step == 'cc'" key="1">
        <CreditCard/>
      </div-->
      <div class="payment section" v-if="step == 'signup'" key="2">
        <Signup/>
      </div>
      <!--div class="payment section" v-else-if="step == 'success'" key="3">
        <Confirm/>
      </div-->
      <div class="payment section" v-else-if="step == 'done'" key="4">
        <Done/>
      </div>
    </transition>
  </div>
</template>

<style lang="scss">
@import "@/assets/sass/ui.scss";
@import "@/assets/sass/main.scss";
@import "@/assets/sass/signup.scss";
</style>

<script>

if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = function (callback, thisArg) {
    thisArg = thisArg || window;
    for (var i = 0; i < this.length; i++) {
      callback.call(thisArg, this[i], i, this);
    }
  };
}

import content from "@/assets/content/main.js";
import {
	changeRoute,
	checkLicense,
	checkProg,
	findPlan,
  validEmail,
  fixHeight
} from "@/js/util.js";

import CreditCard from "@/components/CreditCard.vue";
import Signup from "@/components/Signup.vue";
import Confirm from "@/components/Confirm.vue";
import Done from "@/components/Done.vue";

window.onload = function () {
  window.location.hash = "signup";
};
export default {
  name: "Main",
  data: function () {
		return {
			...content,
			progIndex: window.config.progIndex,
			payPlan: window.config.payPlan
		}
	},
	components: { CreditCard, Signup, Confirm, Done },
  mounted() {
    if (this.$route.hash == "") {
      window.history.replaceState(null, "Enklu", "/signup#signup");
      this.step = "signup";
    } else {
      this.step = this.$route.hash.substring(1);
    }

    if (window.innerWidth > 960) {
      this.fixHeight(document.querySelectorAll(".price__item"));
    }
    window.addEventListener("resize", this.getWidth);
  },
  watch: {
    step() {
      window.scrollTo(0, 0);
    },
  },
  methods: {
    changeRoute: (val) => changeRoute(this, val),
    checkLicense,
		checkProg,
    validEmail,
    fixHeight,
		findPlan(val) {
			const self = this
			findPlan(self, val);
		},
    getWidth() {
      this.desk = window.innerWidth > 1200 ? true : false;
    },
    chooseProg(i) {
      return this.list[i];
    }
  },
};
</script>
